import { FaCircleNodes, FaCircleUser, FaEye, FaHashtag, FaNetworkWired, FaPenToSquare, FaServer, FaTrashCan } from "react-icons/fa6";
import { MasterDataNumBadge } from "../../../../../components/badge/MasterDataNumbBadge";
import { SkeletonRow } from "../../../../../components/skeleton/SkeletonRow";
import { OltActionBtn } from "../components/OltActionButton";
import { useNavigate } from "react-router-dom";


export const OltTable = ({ loading, data, keyword, setOpenDeleteModal, setDeleteId }) => {

    const navigate = useNavigate();

    const columns = [
        { key: "no", label: "No", align: "center", width: "55px" },
        { key: "mainPort", label: "Port Utama", align: "center", width: "80px" },
        { key: "name", label: "Nama OLT", align: "left" },
        { key: "port", label: "Port", align: "center", width: "80px" },
        { key: "pop", label: "POP", align: "center", width: "80px" },
        { key: "odc", label: "ODC", align: "center", width: "80px" },
        { key: "odp", label: "ODP", align: "center", width: "80px" },
        { key: "pppoe", label: "User PPPoE", align: "center", width: "110px" },
        { key: "action", label: "Aksi", align: "center", width: "130px" },
    ];

    return (
        <>
            <section
                className="hidden lg:block rounded-2xl overflow-hidden"
                style={{
                    background: "rgba(15, 23, 42, 0.5)",
                    border: "1px solid rgba(51, 65, 85, 0.3)",
                    backdropFilter: "blur(12px)",
                }}
                aria-label="Tabel OLT"
            >
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        {/* Head */}
                        <thead>
                            <tr
                                className="border-b"
                                style={{ background: "rgba(15, 23, 42, 0.7)", borderColor: "rgba(51, 65, 85, 0.3)" }}
                            >
                                {columns.map((col) => (
                                    <th
                                        key={col.key}
                                        className={`px-5 py-3.5 text-xs font-semibold uppercase tracking-wider text-slate-400 ${col.align === "center" ? "text-center" : "text-left"
                                            }`}
                                        style={col.width ? { width: col.width } : undefined}
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        {/* Body */}
                        <tbody className="divide-y" style={{ borderColor: "rgba(51, 65, 85, 0.15)" }}>
                            {loading && !data && (
                                <>{[...Array(6)].map((_, i) => <SkeletonRow key={i} cols={columns.length} />)}</>
                            )}

                            {!loading && (!data || data?.length === 0) && (
                                <tr>
                                    <td colSpan={columns.length} className="px-5 py-16 text-center">
                                        <div className="flex flex-col items-center gap-3">
                                            <div
                                                className="w-16 h-16 rounded-2xl flex items-center justify-center"
                                                style={{ background: "rgba(51, 65, 85, 0.2)", border: "1px solid rgba(51, 65, 85, 0.2)" }}
                                            >
                                                <FaNetworkWired className="text-2xl text-slate-600" />
                                            </div>
                                            <div>
                                                <p className="text-slate-400 font-medium">Tidak ada data Olt ditemukan</p>
                                                <p className="text-xs text-slate-500 mt-1">
                                                    {keyword ? "Coba ubah kata kunci pencarian" : "Belum ada Olt yang terdaftar"}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}

                            {!loading &&
                                data?.map((item, index) => (
                                    <tr
                                        key={item.id}
                                        className="transition-colors duration-150"
                                        style={{ background: "transparent" }}
                                        onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(0, 180, 216, 0.04)"; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
                                    >
                                        {/* No */}
                                        <td className="px-5 py-3.5 text-center text-slate-500 font-mono text-xs">
                                            {data.indexOf(item) + 1}
                                        </td>

                                        {/* Main Port */}
                                        <td className="px-5 py-3.5 text-center">
                                            <MasterDataNumBadge
                                                value={item.main_port}
                                                icon={FaCircleNodes}
                                                color="#a78bfa"
                                                bg="rgba(167, 139, 250, 0.08)"
                                                border="rgba(167, 139, 250, 0.12)"
                                            />
                                        </td>

                                        {/* Nama + Icon */}
                                        <td className="px-5 py-3.5">
                                            <div className="flex items-center gap-3">
                                                <div
                                                    className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                                                    style={{
                                                        background: "linear-gradient(135deg, rgba(0,180,216,0.15), rgba(0,119,182,0.08))",
                                                        border: "1px solid rgba(0,180,216,0.15)",
                                                    }}
                                                >
                                                    <FaNetworkWired className="text-xs text-ocean-500" />
                                                </div>
                                                <span className="font-semibold text-gray-100">{item.name}</span>
                                            </div>
                                        </td>

                                        {/* Port */}
                                        <td className="px-5 py-3.5 text-center">
                                            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold text-ocean-400 bg-ocean-500/8 border border-ocean-500/10">
                                                <FaServer className="text-[10px]" />
                                                {item.port ?? "-"}
                                            </span>
                                        </td>

                                        {/* Pop */}
                                        <td className="px-5 py-3.5 text-center">
                                            {item.splitter ? (
                                                <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg text-xs font-bold text-amber-400 bg-amber-500/8 border border-amber-500/10">
                                                    <FaHashtag className="text-[10px]" />
                                                    {item.pop}
                                                </span>
                                            ) : (
                                                <span className="text-slate-600 text-xs">—</span>
                                            )}
                                        </td>

                                        {/* ODC */}
                                        <td className="px-5 py-3.5 text-center">
                                            <MasterDataNumBadge
                                                value={item.odc}
                                                icon={FaCircleNodes}
                                                color="#a78bfa"
                                                bg="rgba(167, 139, 250, 0.08)"
                                                border="rgba(167, 139, 250, 0.12)"
                                            />
                                        </td>

                                        {/* ODP */}
                                        <td className="px-5 py-3.5 text-center">
                                            <MasterDataNumBadge
                                                value={item.odp}
                                                icon={FaHashtag}
                                                color="#34d399"
                                                bg="rgba(52, 211, 153, 0.08)"
                                                border="rgba(52, 211, 153, 0.12)"
                                            />
                                        </td>

                                        {/* User PPPoE */}
                                        <td className="px-5 py-3.5 text-center">
                                            <MasterDataNumBadge
                                                value={item.pppoe}
                                                icon={FaCircleUser}
                                                color="#48CAE4"
                                                bg="rgba(72, 202, 228, 0.08)"
                                                border="rgba(72, 202, 228, 0.12)"
                                            />
                                        </td>

                                        {/* Aksi */}
                                        <td className="px-5 py-3.5">
                                            <div className="flex items-center justify-center gap-2">
                                                <OltActionBtn icon={FaEye} label="Detail" color="#48CAE4" onClick={() => navigate(`/dashboard/master-data/olt/detail/${item.id}`)} />
                                                <OltActionBtn icon={FaPenToSquare} label="Edit" color="#a78bfa" />
                                                <OltActionBtn icon={FaTrashCan} label="Hapus" color="#f87171"
                                                    onClick={() => {
                                                        setOpenDeleteModal(true)
                                                        setDeleteId(item.id)
                                                    }}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    )
}